import type { ReactNode } from 'react';

import type { Timeseries } from '../../core/types/timeseries.js';

/**
 * The Select subcomponent props
 * @public
 */
export interface TimeseriesSelectProps {
  /**
   * Custom actions handler
   * @param selectedSeries - the series selected in the range, with the specific subset of selected bins
   * @param selectionDomain - the domain of the selection as `[from, to]`
   */
  actions?: (
    selectedSeries: Timeseries[],
    selectionDomain: [Date, Date],
  ) => ReactNode | Promise<ReactNode>;
}

/**
 * Select slot component.
 * @internal
 */
export const Select = (props: TimeseriesSelectProps) => null;

Select['displayName'] = 'Select';
